import { render, staticRenderFns } from "./CentroDiagnosticoComponente.vue?vue&type=template&id=e89bdcbe&scoped=true"
import script from "./CentroDiagnosticoComponente.vue?vue&type=script&lang=js"
export * from "./CentroDiagnosticoComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroDiagnosticoComponente.vue?vue&type=style&index=0&id=e89bdcbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89bdcbe",
  null
  
)

export default component.exports